import { createContext, PropsWithChildren } from 'react';
import { ModelContext } from './ModelProvider';
import { useRhinoDevtoolsEmit } from '../../hooks/dev';
import { RhinoResource } from '../../index';

// Dynamic controller-state bag; consumers read many runtime fields.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ModelIndexContextValue = Record<string, any>;

export const ModelIndexContext = createContext<
  ModelIndexContextValue | undefined
>(undefined);

interface ModelIndexProviderProps {
  model?: RhinoResource;
  [key: string]: unknown;
}

const include = [
  'model',
  'parentId',
  'defaultState',
  'initialState',
  'order',
  'search',
  'filter',
  'totalFilters',
  'fullFilter',
  'totalFullFilters',
  'setDefaultFilter',
  'limit',
  'setLimit',
  'offset',
  'totalPages',
  'page',
  'hasPrevPage',
  'hasNextPage',
  'firstPage',
  'lastPage',
  'total'
];

export const ModelIndexProvider = ({
  children,
  ...props
}: PropsWithChildren<ModelIndexProviderProps>) => {
  const { model } = props;

  useRhinoDevtoolsEmit(
    {
      type: 'ModelIndexContext',
      context: props
    },
    { include }
  );

  return (
    <ModelContext value={{ model }}>
      <ModelIndexContext value={{ ...props }}>{children}</ModelIndexContext>
    </ModelContext>
  );
};
